import { Link } from 'react-router';
import { observer } from 'mobx-react-lite';
import { HelpCircle, Volume2 } from 'lucide-react';
import { useStore } from '@/app/StoreContext';
import { ThemeToggle } from './ThemeToggle';
import { FeedbackSettings } from './FeedbackSettings';
import { ru } from '@/i18n/ru';
import styles from './Header.module.css';

export const Header = observer(function Header() {
  const { onboarding } = useStore();
  return (
    <header className={styles.header}>
      <Link to="/" className={styles.brand}>
        Сквозь
      </Link>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.iconButton}
          aria-label={ru.onboarding.helpIconLabel}
          title={ru.onboarding.helpIconLabel}
          onClick={() => onboarding.open()}
        >
          <HelpCircle size={20} aria-hidden />
        </button>
        <FeedbackSettings
          trigger={
            <button
              type="button"
              className={styles.iconButton}
              aria-label="Звук и вибрация"
              title="Звук и вибрация"
            >
              <Volume2 size={20} aria-hidden />
            </button>
          }
        />
        <ThemeToggle />
      </div>
    </header>
  );
});
